import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts'
import logger from 'shared/services/logger'
import type { Tenant } from 'types/shopConfig'

interface ImageFinalProps {
  imageMinWidth?: number
  imageMaxWidth?: number
  imageSizes?: object
}

export const getFinalImageProps = (
  imageMinWidth: number | undefined,
  imageMaxWidth: number | undefined,
  imageSizes: string | undefined
): ImageFinalProps => {
  const finalProps: ImageFinalProps = {}

  try {
    if (imageSizes != null) {
      finalProps.imageSizes =
        typeof imageSizes === 'string' ? JSON.parse(imageSizes) : imageSizes
    }
    if (imageMinWidth != null) {
      finalProps.imageMinWidth = imageMinWidth
    }
    if (imageMaxWidth != null) {
      finalProps.imageMaxWidth = imageMaxWidth
    }
  } catch (error) {
    logger.error(error)
  }

  return finalProps
}

export const getWidForCrosssellWideExperiment = (tenant: Tenant) => {
  switch (tenant) {
    case TENANT_AT:
      return 461
    case TENANT_FR:
      return 286
    case TENANT_CH:
      return 468
    case TENANT_IT:
      return 285
    case TENANT_COM:
    default:
      return 452
  }
}
